export default function CreateTemplatePage() {
  return (
    <div>
      <h2 style={{ fontSize: "22px", fontWeight: 700 }}>Create New Template</h2>
      <p style={{ marginTop: 10, color: "#666" }}>
        Template builder UI goes here.
      </p>
    </div>
  );
}
